<app-screen-content [isLoading]="model.isLoading">
  <div body>
    <ng-template #confirmationModal let-modal>
      <div class="modal-header">
        <h4 class="modal-title">Attention</h4>
      </div>
      <div class="modal-body">
        You are only required to provide one of these information, if you choose
        another option, your previous inputs will not be saved.
        <p>Would you like to continue?</p>
      </div>
      <div class="modal-footer">
        <app-primary-button
          buttonType="button"
          [outline]="true"
          (click)="modal.dismiss()"
        >
          No
        </app-primary-button>
        <app-primary-button buttonType="button" (click)="modal.close('save')">
          Yes
        </app-primary-button>
      </div>
    </ng-template>

    <form [formGroup]="form" (ngSubmit)="model.onSubmit()">
      <div class="box">
        <div class="question-title ai-question-title">
          Please read the following for your considerations to be an Accredited
          Investor:
        </div>
        <div class="preamble">
          <div
            class="read-icon"
            [class.read]="isReadAccreditedInvestorDescriptionControl.value"
            [class.unread]="!isReadAccreditedInvestorDescriptionControl.value"
          ></div>
          <span
            class="blue-link"
            (click)="showAccreditedInvestorDescriptionModal()"
            >Detailed description of Accredited Investor</span
          >
        </div>
        <div class="preamble">
          <div
            class="read-icon"
            [class.read]="isReadAccreditedInvestorExplanationControl.value"
            [class.unread]="!isReadAccreditedInvestorExplanationControl.value"
          ></div>
          <a
            href="./assets/pdf/Schedule_2.pdf"
            target="_blank"
            class="blue-link"
            (click)="handleOnClickAccreditedInvestorExplanation()"
            >Explanation of being treated as an Accredited Investor under the
            consent provisions</a
          >
        </div>
      </div>
      <div class="box">
        <div class="question-title">
          Would your organisation like to be considered as an Accredited
          Investor?
        </div>
        <div class="row">
          <div class="col-lg-6 radio-wrapper">
            <app-radio
              name="isOptInAccreditedInvestor"
              formControlName="isOptInAccreditedInvestor"
              [radioValue]="true"
              label="Yes"
              [value]="isOptInAccreditedInvestorControl.value"
              (click)="handleOnSelectAccreditedInvestorOptIn($event, true)"
            ></app-radio>
          </div>
          <div class="col-lg-6 radio-wrapper">
            <app-radio
              name="isOptInAccreditedInvestor"
              formControlName="isOptInAccreditedInvestor"
              [radioValue]="false"
              label="No"
              [value]="isOptInAccreditedInvestorControl.value"
              (click)="handleOnSelectAccreditedInvestorOptIn($event, false)"
            ></app-radio>
          </div>
        </div>

        <div
          *ngIf="isOptInAccreditedInvestorControl.value"
          class="ai-form-container"
        >
          <div class="sub-title">
            Please upload any of these supporting documents for review
          </div>
          <div
            *ngIf="
              !auditedBalanceSheetFileFormArray.length &&
              !otherDocumentFormArray.length &&
              (auditedBalanceSheetFileFormArray?.touched ||
                otherDocumentFormArray.touched)
            "
            class="error fna-mt-10"
          >
            Please upload at least one document
          </div>
          <div class="box-white">
            <div class="title">Most recent audited balance sheet</div>
            <div class="description">
              By uploading, I confirm I have uploaded the most recent audited
              balance sheet of my corporation
            </div>
            <app-file-upload
              class="audited-balance-sheet-file-upload"
              [maxNoOfUpload]="1"
              [form]="auditedBalanceSheetFileFormGroup"
              (handleError)="showAuditedBalanceSheetErrorModal($event)"
            ></app-file-upload>
          </div>
          <div class="box-white">
            <div class="title">Other supporting documents</div>
            <div class="description">You may upload more than one document</div>
            <app-file-upload
              class="audited-balance-sheet-file-upload"
              [maxNoOfUpload]="3"
              [form]="otherDocumentFormGroup"
              (handleError)="showOtherDocumentErrorModal($event)"
            ></app-file-upload>
          </div>
        </div>
      </div>

      <div class="bottom-nav">
        <app-back-button (click)="goToPreviousScreen()"></app-back-button>

        <app-next-button
          buttonType="submit"
          [disabled]="isOptInAccreditedInvestorControl.errors?.required ||
          !isReadAccreditedInvestorDescriptionControl.value ||
          !isReadAccreditedInvestorExplanationControl.value "
          
          *ngIf="!isOptInAccreditedInvestorControl.value"
        ></app-next-button>
        <app-red-button
          buttonType="submit"
          [disabled]="
            !auditedBalanceSheetFileFormArray.length &&
            !otherDocumentFormArray.length
          "
          *ngIf="isOptInAccreditedInvestorControl.value"
          >Submit</app-red-button
        >
      </div>
    </form>

    <div *ngIf="globals.isDebug">
      <h3>Information for developers, please ignore</h3>
      <h4>Data</h4>
      <pre class="debug-log-mono">{{ model.data | json }}</pre>
      <h4>Model</h4>
      <h5>Form value</h5>
      <pre class="debug-log-mono">{{ form.value | json }}</pre>
    </div>
  </div>
</app-screen-content>
